import { render, staticRenderFns } from "./ReviewText.vue?vue&type=template&id=47450886&"
import script from "./ReviewText.vue?vue&type=script&lang=js&"
export * from "./ReviewText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports